import {FlatList, ListRenderItemInfo} from "react-native";
import React, {useContext, useEffect, useState} from "react";
import Game from "../../rest/jtmc/models/Game";
import AppConfigContext from "../../contexts/AppConfigContext";
import Order from "../../rest/jtmc/models/Order";

export default function OrderHistoryList(props: { renderItem: (item: ListRenderItemInfo<Order>) => any }) {
    const [orders, setOrders] = useState<Order[]>([]);
    const fetch = useContext(AppConfigContext).fetch;

    useEffect(()=>{
        fetch.Auth.requests.ordersHistory().then(orders=>{
            setOrders(orders);
        });
    }, []);

    return <FlatList data={orders}
                     renderItem={(rItem) => {
                         return props.renderItem(rItem);
                     }}/>
}